// extracted by mini-css-extract-plugin
module.exports = {"banner":"CountdownBanner_banner__BJJxd","countdown":"CountdownBanner_countdown___xDci","button":"CountdownBanner_button__1KztB","link":"CountdownBanner_link__TkwKk"};